/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const triageUpcomingClipSchema = z.object({
  id: z.number(),
  vaultPath: z.string().nullable(),
  startMs: z.number().nullable(),
  endMs: z.number().nullable(),
  cropStatus: z.string().nullable(),
  baseLocalPath: z.string().nullable(),
  title: z.string().nullable(),
});

export const getCollectionTriageUpcomingResponseSchema = createApiResponseSchema(
  z.array(triageUpcomingClipSchema),
) as z.ZodSchema<IAPI<ITriageUpcomingClip[]>>;

export interface ITriageUpcomingClip {
  id: number;
  vaultPath: string | null;
  startMs: number | null;
  endMs: number | null;
  cropStatus: string | null;
  baseLocalPath: string | null;
  title: string | null;
}

export type IGetCollectionTriageUpcomingResponse = IAPI<ITriageUpcomingClip[]>;
